"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _reactContentLoader = _interopRequireDefault(require("react-content-loader")),
    _classnames = _interopRequireDefault(require("classnames")),
    _viewTypes = require("../../../constants/viewTypes"),
    _placeholder = require("../styles/placeholder");

require("../styles/_placeholder.scss");

var X_COORD_ADJUST = 60;

function getCalculatedXCoord(a, b) {
  var c = b.shouldAdjust;
  return "".concat(c ? a + X_COORD_ADJUST : a);
}

var Placeholder = function Placeholder(a) {
  var b = a.view,
      c = a.hasBulkActions;
  return _react["default"].createElement(_react["default"].Fragment, null, "grid" === b ? _react["default"].createElement(_reactContentLoader["default"], {
    height: 205,
    width: 205,
    speed: 1.5,
    primaryColor: "rgb(232, 236, 240, 0.75)",
    secondaryColor: "rgb(232, 236, 240, 0.2)",
    className: (0, _classnames["default"])("grid-placeholder", _placeholder.GRID_PLACEHOLDER)
  }, _react["default"].createElement("rect", {
    x: "20",
    y: "20",
    rx: "0",
    ry: "0",
    width: "90",
    height: "90"
  }), _react["default"].createElement("rect", {
    x: "120",
    y: "23",
    rx: "4",
    ry: "4",
    width: "63",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: "120",
    y: "43",
    rx: "4",
    ry: "4",
    width: "45",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: "120",
    y: "63",
    rx: "3",
    ry: "3",
    width: "50",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: "120",
    y: "83",
    rx: "4",
    ry: "4",
    width: "63",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: "20",
    y: "133",
    rx: "3",
    ry: "3",
    width: "150",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: "20",
    y: "153",
    rx: "3",
    ry: "3",
    width: "91",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: "20",
    y: "173",
    rx: "3",
    ry: "3",
    width: "162",
    height: "10"
  })) : _react["default"].createElement("div", {
    className: "list-placeholder"
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])("list-placeholder__background", {
      "list-placeholder__background--with-bulk-actions": c
    })
  }), _react["default"].createElement(_reactContentLoader["default"], {
    height: 134,
    width: 700,
    speed: 1.5,
    primaryColor: "rgb(232, 236, 240, 0.75)",
    secondaryColor: "rgb(232, 236, 240, 0.2)",
    preserveAspectRatio: "xMinYMid meet",
    className: _placeholder.LIST_PLACEHOLDER
  }, c ? _react["default"].createElement("rect", {
    x: "0",
    y: "55",
    rx: "4",
    ry: "4",
    width: "25",
    height: "25"
  }) : null, _react["default"].createElement("rect", {
    x: getCalculatedXCoord(27, {
      shouldAdjust: c
    }),
    y: "22",
    rx: "6",
    ry: "6",
    width: "90",
    height: "90"
  }), _react["default"].createElement("rect", {
    x: getCalculatedXCoord(150, {
      shouldAdjust: c
    }),
    y: "30",
    rx: "3",
    ry: "3",
    width: "380",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: getCalculatedXCoord(150, {
      shouldAdjust: c
    }),
    y: "50",
    rx: "3",
    ry: "3",
    width: "530",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: getCalculatedXCoord(150, {
      shouldAdjust: c
    }),
    y: "70",
    rx: "3",
    ry: "3",
    width: "200",
    height: "10"
  }), _react["default"].createElement("rect", {
    x: getCalculatedXCoord(150, {
      shouldAdjust: c
    }),
    y: "90",
    rx: "3",
    ry: "3",
    width: "450",
    height: "10"
  }))));
},
    _default = Placeholder;

exports["default"] = _default;